import { useEffect } from 'react';

import axios, { AxiosRequestConfig } from 'axios';
import { getAddressesBalances } from 'eth-balance-checker/lib/ethers';
import { BigNumber, ethers } from 'ethers';
import { useAccount } from 'wagmi';

import { useGlobalContext } from '../AppContext';
import { Options, ResultData } from '../constants/interfaces';
import {
  fetch_favorite_tokens,
  fetch_favorite_wallets,
  fetch_favorite_whales,
  fetch_vesting_calendars,
} from './apiOperations';
import { networks } from './constants';
//import tokens_avalanche from './data/tokens_avalanche.json';
//import tokens_bsc from './data/tokens_bsc.json';
//import tokens_eth from './data/tokens_eth.json';
//import tokens_moonbeam from './data/tokens_moonbeam.json';
//import tokens_moonriver from './data/tokens_moonriver.json';
//import tokens_polygon from './data/tokens_polygon.json';
//import mantle_tokens from './mantle_tokens.json';

// https://github.com/viaprotocol/tokenlists/tree/main/tokenlists

export const fetchCoinDataFromCoingecko = async () => {
  const {
    setTokenDetails,
    setTokensEth,
    setTokensBsc,
    setTokensPolygon,
    setTokensAvalanche,
    setTokensMoonbeam,
    setTokensMoonriver,
    setTokensMantle,
    setAllow,
  } = useGlobalContext();

  const fetchDetails = async () => {
    const tmpTokenDetails = await fetchCoinDetails();
    setTokenDetails(tmpTokenDetails);

    // eth
    const tokens_eth_response = await fetch('https://tokens.coingecko.com/ethereum/all.json');
    const tokens_eth = await tokens_eth_response.json();
    setTokensEth(tokens_eth);

    // bsc
    const tokens_bsc_response = await fetch(
      'https://tokens.coingecko.com/binance-smart-chain/all.json',
    );
    const tokens_bsc = await tokens_bsc_response.json();
    setTokensBsc(tokens_bsc);

    // polygon
    const tokens_polygon_response = await fetch(
      'https://tokens.coingecko.com/polygon-pos/all.json',
    );
    const tokens_polygon = await tokens_polygon_response.json();
    setTokensPolygon(tokens_polygon);

    // avalanche
    const tokens_avalanche_response = await fetch(
      'https://tokens.coingecko.com/avalanche/all.json',
    );
    const tokens_avalanche = await tokens_avalanche_response.json();
    setTokensAvalanche(tokens_avalanche);

    // mantle

    const tokens_mantle_response = await fetch('https://tokens.coingecko.com/mantle/all.json');
    const tokens_mantle = await tokens_mantle_response.json();
    const tmpTokensMantle = { ...tokens_mantle, tokens: tokens_mantle.tokens.slice(1) };
    setTokensMantle(tmpTokensMantle);

    // moonbeam
    const tokens_moonbeam_response = await fetch('https://tokens.coingecko.com/moonbeam/all.json');
    const tokens_moonbeam = await tokens_moonbeam_response.json();
    setTokensMoonbeam(tokens_moonbeam);

    // moonriver
    const tokens_moonriver_response = await fetch(
      'https://tokens.coingecko.com/moonriver/all.json',
    );
    const tokens_moonriver = await tokens_moonriver_response.json();
    setTokensMoonriver(tokens_moonriver);
  };
  useEffect(async () => {
    await fetchDetails();
    const getWallet = document.location.search.split('?q=')[1];
    const allowCheck = true; //localStorage.getItem('allowed') === '1';
    if (getWallet || allowCheck) {
      setAllow(true);
    }
  }, []);
};

export const tryToReconnect = () => {
  const { setAddress, setCustomSearch, connectedWallets } = useGlobalContext();
  const { address: account, isConnected } = useAccount();

  useEffect(() => {
    if (isConnected && connectedWallets) {
      setCustomSearch(false);
      setAddress(account!);
    } else {
      setCustomSearch(true);
    }
  }, [account, isConnected]);
};

export const retrieveAndPrepareAddressData = () => {
  const {
    allow,
    setConfig,
    setDemoMode,
    address,
    setPreparing,
    customSearch,
    setWallets,
    vestingCalendars,
    setVestingCalendars,
    favorites,
    setFavorites,
    whales,
    tokenDetails,
    tokensEth,
    tokensBsc,
    tokensPolygon,
    tokensAvalanche,
    tokensMoonbeam,
    tokensMoonriver,
    tokensMantle,
    setWhales,
    setAddress,
    setPortfolioStatus,
    signed,
    connectedWallets,
    setNft,
    hideMinimumToken,
    hideMinimumWallet,
    systemReady,
    setFirstRun,
  } = useGlobalContext();
  const { address: account } = useAccount();

  useEffect(() => {
    if (!systemReady && localStorage.getItem('firstRun') !== '1') {
      setDemoMode(true);

      console.log('First run initialized.');
    }

    if (!address) {
      console.log('Address is not setted.');
      console.log(systemReady);
      setDemoMode(true);
    } else {
      setFirstRun(true);
      localStorage.setItem('firstRun', '1');
      console.log('Address is setted.');
    }

    const start = Date.now();
    setConfig(false);
    //setWallets([]);
    //console.log('load config');
    //console.log(address, allow);
    if (!address || !allow) {
      console.log('Adress not setted, return');
      setAddress('');
      return;
    } else {
      console.log('');
      console.log('Fething started.');
      console.log('Address: ', address);
      console.log('Connected Wallets:');
      console.log('connectedWallets');
      console.log('');
    }

    // console.log('config false, refresh values from ', address);
    // console.log('config false, connectedWallets', connectedWallets);
    // console.log('config false, wallets', wallets);

    const fetchAllNft = async (wallets: any): Promise<any> => {
      const fullNftData: any = {};
      const ens: any[] = [];

      let erc20Count = 0;
      let polygonCount = 0;
      let bep20Count = 0;
      let moonbeamCount = 0;
      let moonriverCount = 0;
      let mantleCount = 0;
      let avalancheCount = 0;

      const nftMethod = async () => {
        const chains: string[] = ['eth', 'polygon', 'bsc', 'avalanche'];
        for (let i = 0; i < wallets.length; i++) {
          fullNftData[wallets[i].name] = {};
          fullNftData[wallets[i].name].erc20 = [];
          fullNftData[wallets[i].name].polygon = [];
          fullNftData[wallets[i].name].bep20 = [];
          fullNftData[wallets[i].name].avalanche = [];
          fullNftData[wallets[i].name].moonbeam = [];
          fullNftData[wallets[i].name].moonriver = [];
          fullNftData[wallets[i].name].mantle = [];
          fullNftData[wallets[i].name].ens = [];

          const allNFTs: any = {};
          allNFTs.eth = [];
          allNFTs.polygon = [];
          allNFTs.bsc = [];
          allNFTs.avalanche = [];
          allNFTs.moonbeam = [];
          allNFTs.moonriver = [];
          allNFTs.mantle = [];
          for (const chain of chains) {
            const tmp = wallets[i].network
              .replace('erc20', 'eth')
              .replace('bep20', 'bsc')
              .split(',');
            if (!tmp.includes(chain)) continue;

            const configOptions: AxiosRequestConfig = {
              method: 'GET',
              url: `https://deep-index.moralis.io/api/v2/${wallets[i].address}/nft`,
              params: { chain: chain, format: 'decimal', normalizeMetadata: 'false' },
              headers: {
                accept: 'application/json',
                'X-API-Key': 'mJiTuEkOVB9l9t9nG2Q1sCS5p8jZIGiXCbuXpS13VTHfBmcj74a5AusRsIBueKN1',
              },
            };
            //
            const result = await axios(configOptions).catch((e: any) => {
              console.log(e);
            });
            if (result && result.data && result.data.result) {
              allNFTs[chain].push(...result.data.result);
              fullNftData[wallets[i].name][
                chain === 'eth' ? 'erc20' : chain === 'bsc' ? 'bep20' : chain
              ].push(...result.data.result);
              fullNftData[wallets[i].name]['erc20'] = [
                ...fullNftData[wallets[i].name]['erc20'].filter(
                  (item: any) =>
                    item.token_address !== '0x57f1887a8bf19b14fc0df6fd9b2acc9af147ea85',
                ),
              ];
            }
          }

          if (allNFTs) {
            for (const chain of chains) {
              if (allNFTs[chain]) {
                Object.values(allNFTs[chain]).filter((item: any) => {
                  // it means this nft is an ens
                  if (item.token_address === '0x57f1887a8bf19b14fc0df6fd9b2acc9af147ea85') {
                    ens.push(item);
                    fullNftData[wallets[i].name].ens.push(item);
                  } else {
                    if (chain === 'eth') {
                      erc20Count++;
                    } else if (chain === 'polygon') {
                      polygonCount++;
                    } else if (chain === 'bsc') {
                      bep20Count++;
                    } else if (chain === 'moonbeam') {
                      moonbeamCount++;
                    } else if (chain === 'moonriver') {
                      moonriverCount++;
                    } else if (chain === 'avalanche') {
                      avalancheCount++;
                    } else if (chain === 'mantle') {
                      mantleCount++;
                    }
                  }
                });
              }
            }
          }
        }
        console.log(fullNftData);
        setNft(fullNftData);
      };

      await nftMethod();

      return {
        ens: {
          erc20: ens.length,
          polygon: 0,
          bep20: 0,
          avalanche: 0,
          moonbeam: 0,
          moonriver: 0,
          mantle: 0,
        },
        nft: {
          erc20: erc20Count,
          polygon: polygonCount,
          bep20: bep20Count,
          moonbeam: moonbeamCount,
          moonriver: moonriverCount,
          mantle: mantleCount,
          avalanche: avalancheCount,
        },
      };
    };

    const fetchMoonbeamLP = async (tokens: any[], availableTokens: any[]): Promise<any> => {
      const pairsArray = tokens.map((item: any) => item.address.toLowerCase());

      const data = JSON.stringify({
        operationName: 'pairsQuery',
        variables: {
          first: 1000,
          orderBy: 'reserveUSD',
          orderDirection: 'desc',
        },
        query:
          'query pairsQuery($first: Int! = 1000, $orderBy: String! = "reserveUSD", $orderDirection: String! = "desc") {\n  pairs(first: $first, orderBy: $orderBy, orderDirection: $orderDirection) {\n    ...pairFields\n    __typename\n  }\n}\n\nfragment pairFields on Pair {\n  id\n  reserveUSD\n  volumeUSD\n  __typename\n  token1 {\n    ...pairTokenFields\n    __typename\n  }\n  token0 {\n    ...pairTokenFields\n    __typename\n  }\n  liquidityProviderCount\n}\n\nfragment pairTokenFields on Token {\n  id\n  name\n  symbol\n  totalLiquidity\n  __typename\n }',
      });

      const config = {
        method: 'post',
        url: 'https://api.thegraph.com/subgraphs/name/solarbeamio/solarflare-subgraph',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      const tmp = await axios(config);
      const pairs = tmp.data.data.pairs as Root[];
      const matchedPairs = pairs
        .filter(
          item =>
            pairsArray.includes(item.token0.id.toLowerCase()) &&
            pairsArray.includes(item.token1.id.toLowerCase()),
        )
        .map((obj: any) => ({
          ...obj,
          network: 'Moonbeam',
          coingeckoid0: tokenDetails[obj.token0.id.toLowerCase()]['coingeckoid'],
          logo0: tokenDetails[obj.token0.id.toLowerCase()]['logoURI'],
          token0amount:
            availableTokens[tokenDetails[obj.token0.id.toLowerCase()]['coingeckoid']].amount,
          coingeckoid1: tokenDetails[obj.token1.id.toLowerCase()]['coingeckoid'],
          logo1: tokenDetails[obj.token1.id.toLowerCase()]['logoURI'],
          token1amount:
            availableTokens[tokenDetails[obj.token1.id.toLowerCase()]['coingeckoid']].amount,
        }));

      return matchedPairs;
    };

    const fetchMoonriverLP = async (tokens: any[], availableTokens: any[]): Promise<any> => {
      const pairsArray = tokens.map((item: any) => item.address.toLowerCase());

      const data = JSON.stringify({
        operationName: 'pairsQuery',
        variables: {
          first: 1000,
          orderBy: 'reserveUSD',
          orderDirection: 'desc',
        },
        query:
          'query pairsQuery($first: Int! = 1000, $orderBy: String! = "reserveUSD", $orderDirection: String! = "desc") {\n  pairs(first: $first, orderBy: $orderBy, orderDirection: $orderDirection) {\n    ...pairFields\n    __typename\n  }\n}\n\nfragment pairFields on Pair {\n  id\n  reserveUSD\n  volumeUSD\n  __typename\n  token1 {\n    ...pairTokenFields\n    __typename\n  }\n  token0 {\n    ...pairTokenFields\n    __typename\n  }\n  liquidityProviderCount\n}\n\nfragment pairTokenFields on Token {\n  id\n  name\n  symbol\n  totalLiquidity\n  __typename\n }',
      });

      const config = {
        method: 'post',
        url: 'https://api.thegraph.com/subgraphs/name/solarbeamio/amm-v2',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      const tmp = await axios(config);
      const pairs = tmp.data.data.pairs as Root[];
      const matchedPairs = pairs
        .filter(
          item =>
            pairsArray.includes(item.token0.id.toLowerCase()) &&
            pairsArray.includes(item.token1.id.toLowerCase()),
        )
        .map((obj: any) => ({
          ...obj,
          network: 'Moonriver',
          coingeckoid0: tokenDetails[obj.token0.id.toLowerCase()]['coingeckoid'],
          logo0: tokenDetails[obj.token0.id.toLowerCase()]['logoURI'],
          token0amount:
            availableTokens[tokenDetails[obj.token0.id.toLowerCase()]['coingeckoid']].amount,
          coingeckoid1: tokenDetails[obj.token1.id.toLowerCase()]['coingeckoid'],
          logo1: tokenDetails[obj.token1.id.toLowerCase()]['logoURI'],
          token1amount:
            availableTokens[tokenDetails[obj.token1.id.toLowerCase()]['coingeckoid']].amount,
        }));

      return matchedPairs;
    };

    async function fetchData(): Promise<void> {
      setPreparing(true);

      const parsedData: any = {};
      parsedData.minimumTokenAmount = 0;
      parsedData.minimumWalletAmount = 0;
      parsedData.nftLoaded = false;
      parsedData.balance = 0;
      parsedData.fees = 0;
      parsedData.volume = 0;
      parsedData.top10 = [];
      parsedData.heatMapMarket = [];
      parsedData.heatMapPortfolio = [];
      parsedData.pnl = {};
      parsedData.pnl.amount = 0;
      parsedData.pnl.ratio = 0;
      parsedData.networks = {};
      parsedData.globalNetworks = {};
      parsedData.tokens = {};
      parsedData.moonbeamLP = [];
      parsedData.moonriverLP = [];

      const promiseArray: any[] = [];
      let tmpWallets: any[] = [];

      if (customSearch) {
        tmpWallets = [
          {
            name: 'Wallet',
            address: address,
            network: 'erc20,bep20,polygon,avalanche,moonbeam,moonriver,mantle',
            networkGroup: 'erc20,bep20,polygon,avalanche,moonbeam,moonriver,mantle',
          },
        ];
        setWallets([...tmpWallets]);
        //console.log('custom search initialize wallet', tmpWallets);
      } else {
        tmpWallets = [...connectedWallets];
        setWallets([...tmpWallets]);
        //console.log('connected wallet search initialize wallets', tmpWallets);
      }

      parsedData.stats = await fetchStats();

      tmpWallets.filter((item: any) => {
        parsedData.networks[item.name] = {};

        promiseArray.push(fetchDetailsFromServer(item.address, tokenDetails));
        //console.log(item);
        promiseArray.push(
          item.network.includes('polygon')
            ? fetchAccountBalance(
                'polygon',
                item.address,
                tokensEth,
                tokensBsc,
                tokensPolygon,
                tokensAvalanche,
                tokensMoonbeam,
                tokensMoonriver,
                tokensMantle,
              )
            : null,
        );
        promiseArray.push(
          item.network.includes('avalanche')
            ? fetchAccountBalance(
                'avalanche',
                item.address,
                tokensEth,
                tokensBsc,
                tokensPolygon,
                tokensAvalanche,
                tokensMoonbeam,
                tokensMoonriver,
                tokensMantle,
              )
            : null,
        );
        promiseArray.push(
          item.network.includes('bep20')
            ? fetchAccountBalance(
                'bep20',
                item.address,
                tokensEth,
                tokensBsc,
                tokensPolygon,
                tokensAvalanche,
                tokensMoonbeam,
                tokensMoonriver,
                tokensMantle,
              )
            : null,
        );
        promiseArray.push(
          item.network.includes('erc20')
            ? fetchAccountBalance(
                'erc20',
                item.address,
                tokensEth,
                tokensBsc,
                tokensPolygon,
                tokensAvalanche,
                tokensMoonbeam,
                tokensMoonriver,
                tokensMantle,
              )
            : null,
        );
        promiseArray.push(
          item.network.includes('moonbeam')
            ? fetchAccountBalance(
                'moonbeam',
                item.address,
                tokensEth,
                tokensBsc,
                tokensPolygon,
                tokensAvalanche,
                tokensMoonbeam,
                tokensMoonriver,
                tokensMantle,
              )
            : null,
        );
        promiseArray.push(
          item.network.includes('moonriver')
            ? fetchAccountBalance(
                'moonriver',
                item.address,
                tokensEth,
                tokensBsc,
                tokensPolygon,
                tokensAvalanche,
                tokensMoonbeam,
                tokensMoonriver,
                tokensMantle,
              )
            : null,
        );

        promiseArray.push(
          item.network.includes('mantle')
            ? fetchAccountBalance(
                'mantle',
                item.address,
                tokensEth,
                tokensBsc,
                tokensPolygon,
                tokensAvalanche,
                tokensMoonbeam,
                tokensMoonriver,
                tokensMantle,
              )
            : null,
        );
      });

      tmpWallets.filter((item: any) => {
        if (item.network) {
          const tmp = item.network.split(',');
          tmp.filter((i: any) => {
            parsedData.globalNetworks[i] = {};
            parsedData.globalNetworks[i].balance = 0;
            parsedData.globalNetworks[i].fees = 0;
            parsedData.globalNetworks[i].volume = 0;
            parsedData.globalNetworks[i].ratio = 0;
            parsedData.globalNetworks[i].pnlAmount = 0;
            parsedData.globalNetworks[i].pnlRatio = 0;
            parsedData.globalNetworks[i].icon = networks[i].icon;
            parsedData.globalNetworks[i].color = networks[i].color;
            parsedData.globalNetworks[i].name = networks[i].name;
            parsedData.globalNetworks[i].tokens = [];

            parsedData.networks[item.name][i] = {};
          });
        }
      });

      const addressChecker = (arr: any, address: string) => {
        return arr.some((el: any) => {
          return el.address === address;
        });
      };

      let tmpTokenIndex: number = 0;
      const promiseResult = await Promise.all(promiseArray);
      console.log(`Token data loaded in ${(Date.now() - start) / 1000} seconds.`);
      const portfolioTokens: string[] = [];
      const networkNatives = [
        'matic-network',
        'avalanche-2',
        'binancecoin',
        'ethereum',
        'moonbeam',
        'moonriver',
        'mantle',
      ];

      tmpWallets.filter((walletDetails: any, walletIndex: number) => {
        ['polygon', 'avalanche', 'bep20', 'erc20', 'moonbeam', 'moonriver', 'mantle'].forEach(
          (n: any, i: number) => {
            if (promiseResult[walletIndex * 8][n] && parsedData.networks[walletDetails.name][n]) {
              parsedData.networks[walletDetails.name][n].tokens = [];
              parsedData.networks[walletDetails.name][n].ens = [];
              parsedData.networks[walletDetails.name][n].fees = { successful: 0, failed: 0 };
              parsedData.networks[walletDetails.name][n].volume = 0;
              parsedData.networks[walletDetails.name][n].newNfts = {};
              parsedData.networks[walletDetails.name][n].nft = {};
              parsedData.networks[walletDetails.name][n].graphData = [];
              parsedData.networks[walletDetails.name][n].balance = 0;
              parsedData.networks[walletDetails.name][n].ratio = 0;
              parsedData.networks[walletDetails.name][n].pnlAmount = 0;
              parsedData.networks[walletDetails.name][n].pnlRatio = 0;
              parsedData.networks[walletDetails.name][n].url = '';
              parsedData.networks[walletDetails.name][n].holders = 0;
              parsedData.networks[walletDetails.name][n].icon = networks[n].icon;
              parsedData.networks[walletDetails.name][n].color = networks[n].color;
              parsedData.networks[walletDetails.name][n].name = networks[n].name;

              parsedData.networks[walletDetails.name][n].tokens = Object.values(
                promiseResult[walletIndex * 8 + i + 1],
              );

              parsedData.networks[walletDetails.name][n].volume =
                promiseResult[walletIndex * 8][n].volume;

              parsedData.networks[walletDetails.name][n].fees.successful =
                promiseResult[walletIndex * 8][n].fees.successful;
              parsedData.networks[walletDetails.name][n].fees.failed =
                promiseResult[walletIndex * 8][n].fees.failed;
              parsedData.networks[walletDetails.name][n].fees.total =
                promiseResult[walletIndex * 8][n].fees.total;

              parsedData.volume += promiseResult[walletIndex * 8][n].volume;
              parsedData.fees += promiseResult[walletIndex * 8][n].fees.total;

              parsedData.globalNetworks[n].volume += promiseResult[walletIndex * 8][n].volume;
              parsedData.globalNetworks[n].fees += promiseResult[walletIndex * 8][n].fees.total;

              parsedData.networks[walletDetails.name][n].tokens.forEach(
                (item: any, index: number) => {
                  item.address = item.address.toLowerCase();
                  if (item.address == 0) {
                    parsedData.networks[walletDetails.name][n].tokens[index].balance = parseFloat(
                      (item.amount * parseFloat(promiseResult[walletIndex * 8][n].price)).toFixed(
                        2,
                      ),
                    );
                    parsedData.networks[walletDetails.name][n].tokens[index].coingeckoid =
                      promiseResult[walletIndex * 8][n].coingeckoid || networkNatives[i];
                    parsedData.networks[walletDetails.name][n].tokens[index].marketcap =
                      promiseResult[walletIndex * 8][n].marketcap || 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].holders =
                      promiseResult[walletIndex * 8][n].holders || 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].pnl.amount =
                      promiseResult[walletIndex * 8][n].pnl24hamount || 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].pnl.ratio =
                      promiseResult[walletIndex * 8][n].pnl24hpercentage || 0;

                    parsedData.networks[walletDetails.name][n].tokens[index].high24h =
                      promiseResult[walletIndex * 8][n].high24h || 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].low24h =
                      promiseResult[walletIndex * 8][n].low24h || 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].ath =
                      promiseResult[walletIndex * 8][n].ath || 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].atl =
                      promiseResult[walletIndex * 8][n].atl || 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].price =
                      promiseResult[walletIndex * 8][n].price || 0;

                    parsedData.networks[walletDetails.name][n].tokens[index].category = 'Platform';
                  } else if (promiseResult[walletIndex * 8].coins[item.address]) {
                    parsedData.networks[walletDetails.name][n].tokens[index].balance = parseFloat(
                      (
                        item.amount *
                        (parseFloat(promiseResult[walletIndex * 8].coins[item.address].price) > 0
                          ? parseFloat(promiseResult[walletIndex * 8].coins[item.address].price)
                          : 0)
                      ).toFixed(5),
                    );

                    parsedData.networks[walletDetails.name][n].tokens[index].category =
                      promiseResult[walletIndex * 8].coins[item.address].category || '';

                    parsedData.networks[walletDetails.name][n].tokens[index].coingeckoid =
                      promiseResult[walletIndex * 8].coins[item.address].coingeckoid || '';
                    parsedData.networks[walletDetails.name][n].tokens[index].marketcap =
                      promiseResult[walletIndex * 8].coins[item.address].marketcap || 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].holders =
                      promiseResult[walletIndex * 8].coins[item.address].holders || 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].pnl.amount =
                      promiseResult[walletIndex * 8].coins[item.address].pnl24hamount || 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].pnl.ratio =
                      promiseResult[walletIndex * 8].coins[item.address].pnl24hpercentage || 0;

                    parsedData.networks[walletDetails.name][n].tokens[index].high24h =
                      promiseResult[walletIndex * 8].coins[item.address].high24h || 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].low24h =
                      promiseResult[walletIndex * 8].coins[item.address].low24h || 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].ath =
                      promiseResult[walletIndex * 8].coins[item.address].ath || 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].atl =
                      promiseResult[walletIndex * 8].coins[item.address].atl || 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].price =
                      promiseResult[walletIndex * 8].coins[item.address].price || 0;
                  } else {
                    parsedData.networks[walletDetails.name][n].tokens[index].balance = 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].marketcap = 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].holders = 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].coingeckoid = '';
                    parsedData.networks[walletDetails.name][n].tokens[index].pnl.amount = 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].pnl.ratio = 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].category = 'Platform';
                    parsedData.networks[walletDetails.name][n].tokens[index].high24h = 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].low24h = 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].ath = 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].atl = 0;
                    parsedData.networks[walletDetails.name][n].tokens[index].price = 0;
                  }

                  if (parsedData.networks[walletDetails.name][n].tokens[index].coingeckoid)
                    portfolioTokens.push(
                      parsedData.networks[walletDetails.name][n].tokens[index].coingeckoid,
                    );

                  parsedData.globalNetworks[n].pnlAmount +=
                    parsedData.networks[walletDetails.name][n].tokens[index].pnl.amount *
                    item.amount;
                  parsedData.globalNetworks[n].balance +=
                    parsedData.networks[walletDetails.name][n].tokens[index].balance;

                  parsedData.networks[walletDetails.name][n].pnlAmount +=
                    parsedData.networks[walletDetails.name][n].tokens[index].pnl.amount *
                    item.amount;
                  parsedData.networks[walletDetails.name][n].balance +=
                    parsedData.networks[walletDetails.name][n].tokens[index].balance;
                  parsedData.balance +=
                    parsedData.networks[walletDetails.name][n].tokens[index].balance;

                  parsedData.tokens[
                    parsedData.networks[walletDetails.name][n].tokens[index].coingeckoid
                      ? parsedData.networks[walletDetails.name][n].tokens[index].coingeckoid
                      : item.address
                  ] = {};
                  parsedData.tokens[
                    parsedData.networks[walletDetails.name][n].tokens[index].coingeckoid
                      ? parsedData.networks[walletDetails.name][n].tokens[index].coingeckoid
                      : item.address
                  ]['name'] = item.name;
                  parsedData.tokens[
                    parsedData.networks[walletDetails.name][n].tokens[index].coingeckoid
                      ? parsedData.networks[walletDetails.name][n].tokens[index].coingeckoid
                      : item.address
                  ]['amount'] = item.amount;
                  parsedData.tokens[
                    parsedData.networks[walletDetails.name][n].tokens[index].coingeckoid
                      ? parsedData.networks[walletDetails.name][n].tokens[index].coingeckoid
                      : item.address
                  ]['balance'] = parsedData.networks[walletDetails.name][n].tokens[index].balance;
                },
              );

              parsedData.networks[walletDetails.name][n].tokens.filter((it: any) => {
                if (addressChecker(parsedData.globalNetworks[n].tokens, it.address)) {
                  //tmpToken = getAddressValue(parsedData.globalNetworks[n].tokens, it.address);
                  tmpTokenIndex = parsedData.globalNetworks[n].tokens.findIndex(
                    (x: any) => x.address === it.address,
                  );
                  parsedData.globalNetworks[n].tokens[tmpTokenIndex].amount += it.amount;
                  parsedData.globalNetworks[n].tokens[tmpTokenIndex].balance += it.balance;
                  parsedData.globalNetworks[n].tokens[tmpTokenIndex].pnl.amount += it.pnl.amount;
                } else {
                  parsedData.globalNetworks[n].tokens.push({ ...it });
                }
              });

              parsedData.pnl.amount += parsedData.networks[walletDetails.name][n].pnlAmount;
              parsedData.networks[walletDetails.name][n].pnlAmount =
                parsedData.networks[walletDetails.name][n].pnlAmount.toFixed(2);
              parsedData.networks[walletDetails.name][n].balance =
                parsedData.networks[walletDetails.name][n].balance.toFixed(2);

              if (
                parsedData.networks[walletDetails.name][n].balance == 0 &&
                parsedData.networks[walletDetails.name][n].pnlAmount == 0
              ) {
                parsedData.networks[walletDetails.name][n].pnlRatio = (0).toFixed(2);
              } else {
                parsedData.networks[walletDetails.name][n].pnlRatio = (
                  (100 * parsedData.networks[walletDetails.name][n].pnlAmount) /
                  (parsedData.networks[walletDetails.name][n].balance -
                    parsedData.networks[walletDetails.name][n].pnlAmount)
                ).toFixed(2);
              }

              parsedData.networks[walletDetails.name][n].age =
                promiseResult[walletIndex * 8][n].age;

              parsedData.networks[walletDetails.name][n].volume =
                parsedData.networks[walletDetails.name][n].volume &&
                parsedData.networks[walletDetails.name][n].volume.toFixed(2);

              parsedData.networks[walletDetails.name][n].fees.successful =
                parsedData.networks[walletDetails.name][n].fees.successful.toFixed(2);
              parsedData.networks[walletDetails.name][n].fees.failed =
                parsedData.networks[walletDetails.name][n].fees.failed.toFixed(2);
              parsedData.networks[walletDetails.name][n].fees.total =
                parsedData.networks[walletDetails.name][n].fees.total.toFixed(2);

              parsedData.networks[walletDetails.name][n].pnlAmount = parseFloat(
                parsedData.networks[walletDetails.name][n].pnlAmount,
              ).toString();
              parsedData.networks[walletDetails.name][n].pnlRatio = parseFloat(
                parsedData.networks[walletDetails.name][n].pnlRatio,
              ).toString();
            }
          },
        );

        ['polygon', 'avalanche', 'bep20', 'erc20', 'moonbeam', 'moonriver', 'mantle'].forEach(
          (n: any) => {
            if (
              parsedData.networks[walletDetails.name][n] &&
              parsedData.networks[walletDetails.name][n].tokens &&
              parsedData.networks[walletDetails.name][n].tokens.length > 0
            ) {
              parsedData.networks[walletDetails.name][n].ratio = Math.round(
                (parsedData.networks[walletDetails.name][n].balance * 100) / parsedData.balance,
              );

              if (
                parsedData.networks[walletDetails.name][n] &&
                parsedData.networks[walletDetails.name][n].tokens &&
                parsedData.networks[walletDetails.name][n].tokens.length > 0
              )
                parsedData.networks[walletDetails.name][n].tokens.forEach(
                  (nn: any, index: number) => {
                    parsedData.networks[walletDetails.name][n].tokens[index].ratio = Math.round(
                      (nn.balance * 100) / parsedData.balance,
                    );
                  },
                );
            }
          },
        );
      });

      ['polygon', 'avalanche', 'bep20', 'erc20', 'moonbeam', 'moonriver', 'mantle'].forEach(
        (n: any) => {
          if (parsedData.globalNetworks[n]) {
            parsedData.globalNetworks[n].ratio = Math.round(
              (parsedData.globalNetworks[n].balance * 100) / parsedData.balance,
            );

            if (
              parsedData.globalNetworks[n].ratio === 0 &&
              parsedData.globalNetworks[n].balance > 0
            ) {
              parsedData.globalNetworks[n].ratio = 0.01;
            }
          }
        },
      );

      parsedData.volume = parsedData.volume.toFixed(2);
      parsedData.fees = parsedData.fees.toFixed(2);
      parsedData.balance = parsedData.balance.toFixed(2);
      parsedData.pnl.amount = parsedData.pnl.amount.toFixed(2);
      parsedData.pnl.ratio = (
        (100 * parsedData.pnl.amount) /
        (parsedData.balance - parsedData.pnl.amount)
      ).toFixed(2);

      setPortfolioStatus(parsedData.pnl.amount > 0 ? 'up' : 'down');

      // nft part
      parsedData.nft = {
        erc20: 0,
        polygon: 0,
        bep20: 0,
        moonbeam: 0,
        moonriver: 0,
        mantle: 0,
        avalanche: 0,
      };
      parsedData.ens = {
        erc20: 0,
        polygon: 0,
        bep20: 0,
        avalanche: 0,
        moonbeam: 0,
        moonriver: 0,
        mantle: 0,
      };

      let [portfolioDetails1, portfolioDetails2, portfolioDetails3, portfolioDetails4] =
        await fetchPortfolioDetailsFromServer(portfolioTokens, parsedData.tokens);

      portfolioDetails1 = portfolioDetails1.sort((a: any, b: any) =>
        parseFloat(b.balance) > parseFloat(a.balance) ? 1 : -1,
      );

      portfolioDetails2 = portfolioDetails2.sort((a: any, b: any) =>
        parseFloat(b.change) > parseFloat(a.change) ? 1 : -1,
      );

      portfolioDetails3 = portfolioDetails3.sort((a: any, b: any) =>
        parseFloat(b.change) > parseFloat(a.change) ? 1 : -1,
      );

      portfolioDetails4 = portfolioDetails4.sort((a: any, b: any) =>
        parseFloat(b.marketcap) > parseFloat(a.marketcap) ? 1 : -1,
      );

      //parsedData.portfolio = portfolioDetailsSorted;
      parsedData.portfolio = portfolioDetails1;
      parsedData.heatMapMarket = portfolioDetails2;
      parsedData.heatMapPortfolio = portfolioDetails3;
      parsedData.top10 = portfolioDetails4;
      // parsedData.favoriteWallets = {await fetch_favorite_wallets(true);}
      parsedData.tokens = Object.fromEntries(
        Object.entries(parsedData.tokens).filter((item: any) => {
          return (
            item[1].balance > 0 && (hideMinimumToken === 0 || item[1].balance > hideMinimumToken)
          );
        }),
      );

      Object.keys(parsedData.networks).forEach((wallet: any) => {
        parsedData.networks[wallet] = Object.fromEntries(
          Object.entries(parsedData.networks[wallet]).filter((item: any) => {
            return (
              item[1].balance > 0 &&
              (hideMinimumWallet === 0 || item[1].balance > hideMinimumWallet)
            );
          }),
        );
      });

      Object.keys(parsedData.networks).forEach((wallet: any) => {
        Object.keys(parsedData.networks[wallet]).forEach((network: any) => {
          if (parsedData.networks[wallet][network].tokens) {
            parsedData.networks[wallet][network].tokens = Object.values(
              Object.fromEntries(
                Object.entries(parsedData.networks[wallet][network].tokens).filter((item: any) => {
                  return (
                    item[1].balance > 0 &&
                    (hideMinimumToken === 0 || item[1].balance > hideMinimumToken)
                  );
                }),
              ),
            );
          }
        });
      });

      parsedData.globalNetworks = {};

      tmpWallets.filter((item: any) => {
        if (item.network) {
          const tmp = item.network.split(',');
          tmp.filter((i: any) => {
            parsedData.globalNetworks[i] = {};
            parsedData.globalNetworks[i].balance = 0;
            parsedData.globalNetworks[i].ratio = 0;
            parsedData.globalNetworks[i].fees = 0;
            parsedData.globalNetworks[i].volume = 0;
            parsedData.globalNetworks[i].pnlAmount = 0;
            parsedData.globalNetworks[i].pnlRatio = 0;
            parsedData.globalNetworks[i].icon = networks[i].icon;
            parsedData.globalNetworks[i].color = networks[i].color;
            parsedData.globalNetworks[i].name = networks[i].name;
            parsedData.globalNetworks[i].tokens = [];
          });
        }
      });

      tmpWallets.filter((walletDetails: any) => {
        ['polygon', 'avalanche', 'bep20', 'erc20', 'moonbeam', 'moonriver', 'mantle'].forEach(
          (n: any) => {
            if (
              parsedData.networks[walletDetails.name] &&
              parsedData.networks[walletDetails.name][n] &&
              parsedData.networks[walletDetails.name][n].tokens
            ) {
              parsedData.globalNetworks[n].volume += parseFloat(
                parsedData.networks[walletDetails.name][n].volume,
              );

              parsedData.globalNetworks[n].fees += parseFloat(
                parsedData.networks[walletDetails.name][n].fees.total,
              );
              parsedData.networks[walletDetails.name][n].tokens.forEach(
                (item: any, index: number) => {
                  parsedData.globalNetworks[n].pnlAmount +=
                    parsedData.networks[walletDetails.name][n].tokens[index].pnl.amount *
                    item.amount;
                  parsedData.globalNetworks[n].balance +=
                    parsedData.networks[walletDetails.name][n].tokens[index].balance;
                },
              );

              parsedData.networks[walletDetails.name][n].tokens.filter((it: any) => {
                if (addressChecker(parsedData.globalNetworks[n].tokens, it.address)) {
                  tmpTokenIndex = parsedData.globalNetworks[n].tokens.findIndex(
                    (x: any) => x.address === it.address,
                  );
                  parsedData.globalNetworks[n].tokens[tmpTokenIndex].amount += it.amount;
                  parsedData.globalNetworks[n].tokens[tmpTokenIndex].balance += it.balance;
                  parsedData.globalNetworks[n].tokens[tmpTokenIndex].pnl.amount += it.pnl.amount;
                } else {
                  parsedData.globalNetworks[n].tokens.push({ ...it });
                }
              });
            }
          },
        );
      });

      parsedData.fees = 0;
      parsedData.volume = 0;
      parsedData.balance = 0;

      Object.keys(parsedData.networks).forEach((wallet: any) => {
        Object.entries(parsedData.networks[wallet]).map((item: any) => {
          if (item[1]) {
            if (item[1].volume) parsedData.volume += parseFloat(item[1].volume);
            if (item[1].fees) parsedData.fees += parseFloat(item[1].fees.total);
            if (item[1].balance) parsedData.balance += parseFloat(item[1].balance);
          }
        });
      });

      parsedData.volume = parsedData.volume.toFixed(2);
      parsedData.fees = parsedData.fees.toFixed(2);
      parsedData.balance = parsedData.balance.toFixed(2);

      ['polygon', 'avalanche', 'bep20', 'erc20', 'moonbeam', 'moonriver', 'mantle'].forEach(
        (n: any) => {
          if (parsedData.globalNetworks[n]) {
            parsedData.globalNetworks[n].ratio = Math.round(
              (parsedData.globalNetworks[n].balance * 100) / parsedData.balance,
            );
            if (
              parsedData.globalNetworks[n].ratio === 0 &&
              parsedData.globalNetworks[n].balance > 0
            ) {
              parsedData.globalNetworks[n].ratio = 0.01;
            }
          }
        },
      );

      Object.keys(parsedData.globalNetworks).forEach((network: any) => {
        if (parsedData.globalNetworks[network].tokens) {
          parsedData.globalNetworks[network].tokens = Object.values(
            Object.fromEntries(
              Object.entries(parsedData.globalNetworks[network].tokens).filter((item: any) => {
                return (
                  item[1].balance > 0 &&
                  (hideMinimumToken === 0 || item[1].balance > hideMinimumToken)
                );
              }),
            ),
          );
        }
      });

      setConfig({ ...parsedData });
      console.log('NFT Loaded:', parsedData.nftLoaded);
      setDemoMode(false);
      setPreparing(false);

      const nftCounts = await fetchAllNft(tmpWallets);

      parsedData.nft = { ...nftCounts.nft };
      parsedData.ens = { ...nftCounts.ens };
      parsedData.nftLoaded = true;
      setConfig({ ...parsedData });
      console.log('NFT Loaded:', parsedData.nftLoaded);

      const moonbeamLP = await fetchMoonbeamLP(
        parsedData.globalNetworks!.moonbeam!.tokens,
        parsedData.tokens,
      );
      parsedData.moonbeamLP = [...moonbeamLP];

      setConfig({ ...parsedData });

      const moonriverLP = await fetchMoonriverLP(
        parsedData.globalNetworks!.moonriver!.tokens,
        parsedData.tokens,
      );
      parsedData.moonriverLP = [...moonriverLP];

      setConfig({ ...parsedData });
      console.log('Config: ', parsedData);
      window.scrollTo(0, 1);

      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    }

    fetchData();
  }, [address, systemReady]);

  useEffect(() => {
    if (!signed || !account || favorites) {
      return;
    }
    console.log('favorites updated');
    async function fetchFavoritesData(): Promise<void> {
      setFavorites({
        tokens: await fetch_favorite_tokens(),
        wallets: await fetch_favorite_wallets(),
      });
    }
    fetchFavoritesData();
    if (favorites) console.log('Favorites: ', favorites);
  }, [favorites, account, signed]);

  useEffect(() => {
    if (!signed || !account || vestingCalendars) {
      return;
    }
    async function fetchVestingCalendarsData(): Promise<void> {
      setVestingCalendars(await fetch_vesting_calendars());
    }
    fetchVestingCalendarsData();
    if (vestingCalendars) console.log('Vesting Calendars: ', vestingCalendars);
  }, [vestingCalendars, account, signed]);

  useEffect(() => {
    if (!signed || !account || whales) {
      return;
    }
    console.log('whales updated');

    async function fetchWhalesData(): Promise<void> {
      setWhales(await fetch_favorite_whales());
    }
    fetchWhalesData();
    if (whales) console.log('Whales: ', whales);
  }, [whales, account, signed]);
};

export const fetchAccountBalance = async (
  network: string,
  address: string,
  tokens_eth,
  tokens_bsc,
  tokens_polygon,
  tokens_avalanche,
  tokens_moonbeam,
  tokens_moonriver,
  tokens_mantle,
): Promise<any> => {
  const result: ResultData = {};
  const obj: any[] = [];
  const chunkSize = 250;
  const promiseArray: any[] = [];
  //const addresses = ['0x10ed43c718714eb63d5aa57b78b54704e256024e'];
  const addresses = [address];
  const tokenList =
    network === 'erc20'
      ? tokens_eth
      : network === 'bep20'
      ? tokens_bsc
      : network === 'avalanche'
      ? tokens_avalanche
      : network === 'polygon'
      ? tokens_polygon
      : network === 'moonbeam'
      ? tokens_moonbeam
      : network === 'moonriver'
      ? tokens_moonriver
      : tokens_mantle;

  obj.push('0x0000000000000000000000000000000000000000');

  if (network === 'erc20') {
    //const provider: any = new ethers.providers.CloudflareProvider();
    // new ethers.providers.JsonRpcBatchProvider();
    const provider: any = new ethers.providers.JsonRpcProvider('https://rpc.ankr.com/eth');

    Object.values(tokens_eth.tokens).filter(
      (item: any) => ethers.utils.isAddress(item.address) && obj.push(item.address),
    );
    const tokens = Object.values(obj);

    const op: Options = { contractAddress: '0xb1f8e55c7f64d203c1400b9d8555d050f94adf39' };

    for (let i = 0; i < tokens.length; i += chunkSize) {
      const chunk = tokens.slice(i, i + chunkSize);
      promiseArray.push(getAddressesBalances(provider, addresses, chunk, op));
    }
  } else if (network === 'bep20') {
    //const provider: any = new ethers.providers.CloudflareProvider();
    const provider: any = new ethers.providers.JsonRpcProvider('https://bsc.nodereal.io');

    Object.values(tokens_bsc.tokens).filter(
      (item: any) => ethers.utils.isAddress(item.address) && obj.push(item.address),
    );
    const tokens = Object.values(obj);

    const op: Options = { contractAddress: '0x2352c63A83f9Fd126af8676146721Fa00924d7e4' };

    for (let i = 0; i < tokens.length; i += chunkSize) {
      const chunk = tokens.slice(i, i + chunkSize);
      promiseArray.push(getAddressesBalances(provider, addresses, chunk, op));
    }
  } else if (network === 'polygon') {
    //const provider: any = new ethers.providers.CloudflareProvider();
    const provider: any = new ethers.providers.JsonRpcProvider('https://rpc.ankr.com/polygon');

    Object.values(tokens_polygon.tokens).filter(
      (item: any) => ethers.utils.isAddress(item.address) && obj.push(item.address),
    );
    const tokens = Object.values(obj);

    const op: Options = { contractAddress: '0x2352c63A83f9Fd126af8676146721Fa00924d7e4' };

    for (let i = 0; i < tokens.length; i += chunkSize) {
      const chunk = tokens.slice(i, i + chunkSize);
      promiseArray.push(getAddressesBalances(provider, addresses, chunk, op));
    }
  } else if (network === 'avalanche') {
    //const provider: any = new ethers.providers.CloudflareProvider();
    const provider: any = new ethers.providers.JsonRpcProvider('https://rpc.ankr.com/avalanche');

    Object.values(tokens_avalanche.tokens).filter(
      (item: any) => ethers.utils.isAddress(item.address) && obj.push(item.address),
    );
    const tokens = Object.values(obj);

    const op: Options = { contractAddress: '0xD023D153a0DFa485130ECFdE2FAA7e612EF94818' };

    for (let i = 0; i < tokens.length; i += chunkSize) {
      const chunk = tokens.slice(i, i + chunkSize);
      promiseArray.push(getAddressesBalances(provider, addresses, chunk, op));
    }
  } else if (network === 'moonbeam') {
    //const provider: any = new ethers.providers.CloudflareProvider();
    const provider: any = new ethers.providers.JsonRpcProvider(
      'https://moonbeam.public.blastapi.io',
    );

    Object.values(tokens_moonbeam.tokens).filter(
      (item: any) => ethers.utils.isAddress(item.address) && obj.push(item.address),
    );
    const tokens = Object.values(obj);

    const op: Options = { contractAddress: '0xf614056a46e293DD701B9eCeBa5df56B354b75f9' };

    for (let i = 0; i < tokens.length; i += chunkSize) {
      const chunk = tokens.slice(i, i + chunkSize);
      promiseArray.push(getAddressesBalances(provider, addresses, chunk, op));
    }
  } else if (network === 'moonriver') {
    //const provider: any = new ethers.providers.CloudflareProvider();
    const provider: any = new ethers.providers.JsonRpcProvider(
      'https://moonriver.public.blastapi.io',
    );

    Object.values(tokens_moonriver.tokens).filter(
      (item: any) => ethers.utils.isAddress(item.address) && obj.push(item.address),
    );
    const tokens = Object.values(obj);

    const op: Options = { contractAddress: '0xDEAa846cca7FEc9e76C8e4D56A55A75bb0973888' };

    for (let i = 0; i < tokens.length; i += chunkSize) {
      const chunk = tokens.slice(i, i + chunkSize);
      promiseArray.push(getAddressesBalances(provider, addresses, chunk, op));
    }
  } else if (network === 'mantle') {
    //const provider: any = new ethers.providers.CloudflareProvider();
    const provider: any = new ethers.providers.JsonRpcProvider('https://rpc.mantle.xyz');

    Object.values(tokens_mantle.tokens).filter(
      (item: any) => ethers.utils.isAddress(item.address) && obj.push(item.address),
    );
    const tokens = Object.values(obj);

    const op: Options = { contractAddress: '0xDEAa846cca7FEc9e76C8e4D56A55A75bb0973888' };

    for (let i = 0; i < tokens.length; i += chunkSize) {
      const chunk = tokens.slice(i, i + chunkSize);
      promiseArray.push(getAddressesBalances(provider, addresses, chunk, op));
    }
  }

  let promiseResult;

  try {
    promiseResult = await Promise.all(promiseArray);
  } catch (e: any) {
    console.log('Network load failed: ', network);
  }

  if (promiseResult && promiseResult.length > 0) {
    for (const i in promiseResult) {
      if (promiseResult[i][addresses[0]]) {
        Object.entries(promiseResult[i][addresses[0]]).forEach((token: any) => {
          if (
            token[0] === '0x0000000000000000000000000000000000000000' ||
            !BigNumber.from(token[1]).eq(0)
          ) {
            result[token[0]] = {
              name: '',
              symbol: '',
              logo: '',
              amount: 0,
              balance: 0,
              ratio: 0,
              marketcap: 0,
              coingeckoid: '',
              volume: 0,
              category: '',
              pnl: { amount: 0, ratio: 0 },
              spam: false,
              graphData: [],
              graphLastDirection: '',
              tokenId: '',
              decimals: 18,
              logoURI: '',
              address: token[0],
            };
            const tmp = tokenList.tokens.find(
              (t: any) => t.address.toLowerCase() === token[0].toLowerCase(),
            );
            if (tmp && tmp['name']) {
              result[token[0]].decimals = tmp['decimals'] || 18;
              result[token[0]].logoURI = tmp['logoURI'] || '';
              result[token[0]].name = tmp['name'] || '';
              result[token[0]].symbol = tmp['symbol'] || '';
              result[token[0]].amount = parseFloat(
                parseFloat(
                  ethers.utils.formatUnits(token[1], result[token[0]]['decimals']),
                ).toFixed(6),
              );
            } else if (token[0] === '0x0000000000000000000000000000000000000000') {
              if (network === 'erc20') {
                result[token[0]].decimals = 18;
                result[token[0]].logoURI = networks.erc20.icon;
                result[token[0]].name = networks.erc20.name;
                result[token[0]].symbol = 'ETH';
              } else if (network === 'bep20') {
                result[token[0]].decimals = 18;
                result[token[0]].logoURI = networks.bep20.icon;
                result[token[0]].name = networks.bep20.name;
                result[token[0]].symbol = 'BNB';
              } else if (network === 'polygon') {
                result[token[0]].decimals = 18;
                result[token[0]].logoURI = networks.polygon.icon;
                result[token[0]].name = networks.polygon.name;
                result[token[0]].symbol = 'MATIC';
              } else if (network === 'avalanche') {
                result[token[0]].decimals = 18;
                result[token[0]].logoURI = networks.avalanche.icon;
                result[token[0]].name = networks.avalanche.name;
                result[token[0]].symbol = 'AVAX';
              } else if (network === 'moonbeam') {
                result[token[0]].decimals = 18;
                result[token[0]].logoURI = networks.moonbeam.icon;
                result[token[0]].name = networks.moonbeam.name;
                result[token[0]].symbol = 'GLMR';
              } else if (network === 'moonriver') {
                result[token[0]].decimals = 18;
                result[token[0]].logoURI = networks.moonriver.icon;
                result[token[0]].name = networks.moonriver.name;
                result[token[0]].symbol = 'MOVR';
              } else if (network === 'mantle') {
                result[token[0]].decimals = 18;
                result[token[0]].logoURI = networks.mantle.icon;
                result[token[0]].name = networks.mantle.name;
                result[token[0]].symbol = 'MNT';
              }

              result[token[0]].amount = parseFloat(
                parseFloat(
                  ethers.utils.formatUnits(token[1], result[token[0]]['decimals']),
                ).toFixed(6),
              );
            }
          }
        });
      }
    }
  }

  return result;
};

export const fetchCoinDetails = async (): Promise<any> => {
  let response: any;
  try {
    response = await axios({
      url: `${process.env.REACT_APP_API}/exportCoinsName.php`,
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });
  } catch (error) {
    // console.log
  }

  return response.data.coins;
};

export const fetchStats = async (): Promise<any> => {
  let response: any;

  try {
    response = await axios({
      url: `${process.env.REACT_APP_API}/fetch-stats.php`,
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });
  } catch (error) {
    // console.log
  }
  return response.data.data;
};

export const fetchDetailsFromServer = async (address: string, tokenDetails: any): Promise<any> => {
  let response: any;

  try {
    response = await axios({
      url: `${process.env.REACT_APP_API}/retrieve-data.php`,
      params: {
        address: address,
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });
  } catch (error) {
    // console.log
  }
  //response.data.coins = { ...tokens.coins };
  response.data.coins = tokenDetails;
  return response.data;
};

export const fetchPortfolioDetailsFromServer = async (
  tokens: string[],
  pt: any[],
): Promise<any[]> => {
  let response: any;
  try {
    response = await axios({
      url: `${process.env.REACT_APP_API}/retrieve-portfolio-data.php`,
      params: {
        tokens: tokens!.join(','),
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });
  } catch (error) {
    // console.log
  }

  const heatmapPortfolio: any[] = [];
  Object.keys(response.data.coins).map((item: any) => {
    if (Math.abs(parseFloat(response.data.coins[item].pnl24hpercentage)) > 0.1)
      heatmapPortfolio.push({
        symbol: response.data.coins[item].symbol,
        change: response.data.coins[item].pnl24hpercentage
          ? parseFloat(parseFloat(response.data.coins[item].pnl24hpercentage).toFixed(1))
          : 0,
      });
  });
  const heatmapMarket: any[] = [];

  Object.keys(response.data.market).map((item: any) => {
    if (Math.abs(parseFloat(response.data.market[item].pnl24hpercentage)) > 0.1)
      heatmapMarket.push({
        marketcap: response.data.market[item].marketcap,
        symbol: response.data.market[item].symbol,
        change: response.data.market[item].pnl24hpercentage
          ? parseFloat(parseFloat(response.data.market[item].pnl24hpercentage).toFixed(1))
          : 0,
      });
  });

  const buyAndSell: any[] = [];

  Object.keys(response.data.market).map((item: any) => {
    if (true || Math.abs(parseFloat(response.data.market[item].pnl24hpercentage)) > 0.1)
      buyAndSell.push({
        coingeckoid: response.data.market[item].coingeckoid,
        name: response.data.market[item].name,
        logo: response.data.market[item].image,
        category: response.data.market[item].category,
        holders: response.data.market[item].holders,
        symbol: response.data.market[item].symbol,
        price: response.data.market[item].price,
        marketcap: response.data.market[item].marketcap,
        uniqueMarket: response.data.market[item].uniqueMarket,
        pnl24hamount: response.data.market[item].pnl24hamount,
        pnl24hpercentage: response.data.market[item].pnl24hpercentage,
        address: response.data.market[item].address && '0',
      });
  });

  const items: any[] = [];

  Object.keys(response.data.coins).map((item: any) => {
    items[item] = {};
    items[item] = { ...response.data.coins[item] };
    items[item].amount = pt[item].amount;
    items[item].balance = pt[item].balance;
  });
  return [items, heatmapMarket, heatmapPortfolio, buyAndSell];
};

export const fetchTokensDetailsFromServer = async (tokens: string[]): Promise<any> => {
  let response: any;
  try {
    response = await axios({
      url: `${process.env.REACT_APP_API}/retrieve-portfolio-data.php`,
      params: {
        tokens: tokens!.join(','),
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });
  } catch (error) {
    // console.log
  }

  const items: any[] = [];

  Object.keys(response.data.coins).map((item: any) => {
    items[item] = {};
    items[item] = { ...response.data.coins[item] };
  });

  return items;
};
